const HOME_LOCATION_SPIELS = {
  ADD_HOME_LOCATION: "ADD HOME LOCATION",
  HOME_LOCATION_ACTION: {
    DELETE: "DELETE",
    EDIT: "EDIT"
  },
  HOME_LOCATION_FIELDS: {
    LATITUDE: "Latitude",
    LONGITUDE: "Longitude",
    REMARKS: "Remarks"
  }
};

const DUMMY_DATA = [
  {
    id: 1,
    latitude: 12,
    longitude: 12,
    name: "Main Entrance A",
    remarks: "Remarks"
  },
  {
    id: 2,
    latitude: 12,
    longitude: 12,
    name: "Main Entrance B",
    remarks: "Remarks 2"
  }
];

export default { DUMMY_DATA, HOME_LOCATION_SPIELS };
